import { Path } from '@/main/router/routerPath';

import { PujcovnaVozidel } from './pujcovnaVozidel';
import { StavPujcovny } from './stavPujcovny';
import { SkladPredmetu } from './skladPredmetu';
import { SkladoveMistoPredmetu } from './skladoveMistoPredmetu';
import { ZarazeniPujcovnaPredmet } from './zarazeniPujcovnaPredmet';
import { ZarazeniPujcovnaVozidlo } from './zarazeniPujcovnaVozidlo';

export const router = new Path('Pujcovna').addChildren([
	PujcovnaVozidel.router,
	StavPujcovny.router,
	SkladPredmetu.router,
	SkladoveMistoPredmetu.router,
	ZarazeniPujcovnaPredmet.router,
	ZarazeniPujcovnaVozidlo.router,
]);
